import { render, staticRenderFns } from "./ShapeBlock.vue?vue&type=template&id=f98f0c5e&scoped=true&"
import script from "./ShapeBlock.vue?vue&type=script&lang=js&"
export * from "./ShapeBlock.vue?vue&type=script&lang=js&"
import style0 from "./ShapeBlock.vue?vue&type=style&index=0&id=f98f0c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98f0c5e",
  null
  
)

export default component.exports